import config from './config.js';
export default () => (`${config.baseAddress}/api/installer/`);


// WEBPACK FOOTER //
// ./src/js/serverApi/installerLinkGenerator.js